import Paper from '@mui/material/Paper';
import InputAdornment from '@mui/material/InputAdornment';
import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export type SearchTextProps = {
  value?: string;
  placeholderText?: string;
  onValueChange?: (newValue: string) => void;
  onClear?: () => void;
};

const SearchText = ({
  value = '',
  placeholderText = '',
  onValueChange = () => {},
  onClear = () => {},
}: SearchTextProps) => {
  return (
    <Paper sx={{ pt: 0.25, pl: 0.5, display: 'flex', alignItems: 'center' }}>
      <IconButton sx={{ padding: 1.25 }} aria-label="search" size="large">
        <SearchIcon />
      </IconButton>
      <InputBase
        sx={{ flex: 1, ml: 1 }}
        placeholder={placeholderText}
        inputProps={{ 'aria-label': placeholderText }}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        endAdornment={
          <InputAdornment position="end" sx={{ padding: 1.25 }}>
            {value.length > 0 ? (
              <IconButton
                aria-label="clear"
                onClick={onClear}
                onMouseDown={(e) => {
                  e.preventDefault();
                }}
                size="large"
              >
                <HighlightOffIcon />
              </IconButton>
            ) : (
              ''
            )}
          </InputAdornment>
        }
      />
    </Paper>
  );
};

export default SearchText;
